<script setup>
import { computed, ref } from 'vue'
import { parseHeziyunData } from '@/utils/heziyunData'

import HzBanner from '@/components/index/HzBanner.vue'

import quickBlock from '@/components/index/quickBlock.vue'
import quickBlockTwo from '@/components/index/quickBlockTwo.vue'
import quickBlockThree from '@/components/index/quickBlockThree.vue'

import shopList from '@/components/index/shopList.vue'
import shopListTow from '@/components/index/shopListTow.vue'

import cloudMarket from '@/components/index/cloudMarket.vue'

import solution from '@/components/index/solution.vue'

import choice from '@/components/index/choice.vue'
import choiceTwo from '@/components/index/choiceTwo.vue'

import cooperativePartner from '@/components/index/cooperativePartner.vue'
import cooperativePartnerTwo from '@/components/index/cooperativePartnerTwo.vue'

import build from '@/components/index/build.vue'

import news from '@/components/index/news.vue'
import newsTow from '@/components/index/newsTow.vue'

import footerCard from '@/components/main/card/footerCard.vue'

const HeziyunData = ref(parseHeziyunData())
console.log('HeziyunData', HeziyunData.value)

const theme = computed(() => HeziyunData.value.theme || {})

const show = (key, value = '1') => {
  return String(theme.value[key] || '') === String(value)
}

// 处理轮播图数据
const processBannerData = (bannerList) => {
  return bannerList?.map(item => ({
    ...item,
    title: item.title ? processText(item.title) : '',
    details: item.details ? processText(item.details) : '',
    small: item.small ? processText(item.small) : ''
  })) || []
}

const processText = (text) => {
  if (!text) return text

  const pattern = /（([a-zA-Z][\w-]*)-([^（）]*(?:（[^（）]*）)*[^（）]*)）|\(([a-zA-Z][\w-]*)-([^()]*(?:\([^()]*\))*[^()]*)\)/g

  const processRecursively = (str) => {
    return str.replace(pattern, (match, chPrefix, chContent, enPrefix, enContent) => {
      let prefix = chPrefix || enPrefix
      let content = chContent || enContent

      if (!prefix || !content) return match

      return `<span class="Heziyun-${prefix}">${processRecursively(content)}</span>`
    })
  }

  return processRecursively(text)
}
</script>

<template>
  <section class="creative-fullpage--slider">
    <div class="banner-horizental">
      <!-- 轮播图 -->
      <HzBanner
        v-if="show('banner')"
        :banner="processBannerData(HeziyunData.banner)"
      />

      <!-- 快捷方块 -->
      <quickBlock
        v-if="show('block', '1')"
        :quick="HeziyunData.block"
      />

      <quickBlockTwo
        v-else-if="show('block', '2')"
        :quick="HeziyunData.block"
      />

      <quickBlockThree
        v-else-if="show('block', '3')"
        :quick="HeziyunData.block"
      />
    </div>
  </section>

  <!-- 商品列表 -->
  <shopList
    v-if="show('shop', '1')"
    :categoryData="HeziyunData.shopType"
    :footer="HeziyunData.global"
  />

  <shopListTow
    v-else-if="show('shop', '2')"
    :categoryData="HeziyunData.shopType"
    :footer="HeziyunData.global"
  />

  <!-- 云市场 -->
  <cloudMarket
    v-if="show('cloudshop', '1')"
    :cloud_app="HeziyunData.cloud_app"
    :footer="HeziyunData.global"
  />

  <!-- 解决方案 -->
  <solution v-if="show('scheme')" />

  <!-- 为什么选择我们 -->
  <choice v-if="show('selectMy', '1')" />
  <choiceTwo v-else-if="show('selectMy', '2')" />

  <!-- 合作伙伴 -->
  <cooperativePartner
    v-if="show('cooperation', '1')"
    :partner="HeziyunData.cooperate"
    :footer="HeziyunData.global"
  />

  <cooperativePartnerTwo
    v-else-if="show('cooperation', '2')"
    :partner="HeziyunData.cooperate"
    :footer="HeziyunData.global"
  />

  <!-- 基础设施建设 -->
  <build
    v-if="show('foundation')"
    :maps="HeziyunData.map"
    :common="HeziyunData.global"
  />

  <!-- 新闻动态 -->
  <news v-if="show('news','1')" />
  <newsTow v-else-if="show('news','2')" />

  <!-- 底部卡片 -->
  <footerCard
    v-if="show('footerCart')"
    :footer="HeziyunData.global"
  />
</template>

<style>
@import 'swiper/css';
@import 'swiper/css/effect-fade';
@import 'swiper/css/pagination';
</style>

<style lang="less" scoped>
:deep(.swiper-wrapper .arco-spin) {
  height: 100%;
}

:deep(.arco-image-error) {
  background-color: transparent;
}

.error-state {
  h3 {
    color: #ef4444;
    margin-bottom: 10px;
  }

  button {
    margin-top: 15px;
    padding: 8px 24px;
    background-color: #3b82f6;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      background-color: #2563eb;
    }
  }
}

body {
  background-color: #f3f5f8 !important;
}

@keyframes gradientAnimation {
  0% {
    background-position: 0% 0%;
  }

  50% {
    background-position: 100% 100%;
  }

  100% {
    background-position: 0% 0%;
  }
}

/* 确保组件容器正确渲染 */
section,
div {
  opacity: 1;
  transition: opacity 0.3s ease;
}

@media (max-width: 768px) {


  :deep(.arco-btn-icon) {
    margin-right: 0 !important;
  }

  :deep(.arco-btn-size-medium) {
    padding: 0 5px;
    margin-right: 10px;
  }
}
</style>
